// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".amp-header__wrapper[data-v-73d322fc]{position:fixed;width:100%;max-width:800px;height:60px;top:0;z-index:10000;background:#000}.amp-header__wrapper .amp-header__container[data-v-73d322fc]{width:100%;height:100%;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center}", ""]);
// Exports
module.exports = exports;
